import * as React from 'react';
import {useSelector} from 'react-redux';
import {InjectedFormProps, reduxForm} from 'redux-form';
import {acceptorCategoriesSelector} from '../../../redux/selectors/acceptors';
import {Forms} from '../../models/forms';
import {AcceptorsFilterForm} from './model';
import View from './view';

export interface AcceptorsFilterProps {
  visuallyImpaired?: boolean;
  onFilterApply?: (formData: AcceptorsFilterForm) => void;
}

const _AcceptorsFilter: React.FC<AcceptorsFilterProps & InjectedFormProps<AcceptorsFilterForm, AcceptorsFilterProps>> =
  ({onFilterApply = () => undefined, handleSubmit, ...props}) => {
    const acceptorCategories = useSelector(acceptorCategoriesSelector());

    const onSubmit = React.useCallback((e: any) => {
      e?.preventDefault();
      handleSubmit(onFilterApply)();
    }, []);

    return <View onSubmit={onSubmit} acceptorCategories={acceptorCategories} {...props} />;
  };

export const AcceptorsFilter = reduxForm<AcceptorsFilterForm, AcceptorsFilterProps>({
  form: Forms.acceptorsFilterForm,
  destroyOnUnmount: false,
})(_AcceptorsFilter);
